import React, { useState } from "react";
//ReactStrap
import { Button, Container, Row, Col } from "reactstrap";
import "assets/css/logos.css";
import { Link } from "react-router-dom";
//React MUI
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@material-ui/icons/Close";

const SearchField = ({ placeholder, data }) => {
  const [filteredData, setFilteredData] = useState([]);
  const [wordEntered, setWordEntered] = useState("");

  const handleFilter = (event) => {
    const searchWord = event.target.value;
    setWordEntered(searchWord);
    const newFilter = data.filter((value) => {
      return value.title.toLowerCase().includes(searchWord.toLowerCase());
    });

    if (searchWord === "") {
      setFilteredData([]);
    } else {
      setFilteredData(newFilter);
    }
  };

  const clearInput = () => {
    setFilteredData([]);
    setWordEntered("");
  };
  return (
    <Container className="Search-Container">
      <Row>
        <Col md="1"></Col>
        <Col md="10">
          <div className="search">
            <div className="searchInputs">
              <TextField
                type="text"
                fullWidth
                id="outlined-basic"
                value={wordEntered}
                onChange={handleFilter}
                label={placeholder}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <Button
                      style={{ width: "20%" }}
                      type="submit"
                      className="btn-round"
                      color="info"
                      onClick={clearInput}
                    >
                      <div className="searchIcon">
                        {filteredData.length === 0 ? (
                          <SearchIcon />
                        ) : (
                          <CloseIcon
                            style={{ fontSize: "35px" }}
                            id="clearBtn"
                            onClick={clearInput}
                          />
                        )}
                      </div>
                    </Button>
                  ),
                }}
              />
            </div>
            {filteredData.length !== 0 && (
              <div className="dataResult">
                {filteredData.slice(0, 5).map((value, key) => {
                  return (
                    <Link
                      className="dataItem"
                      to={{
                        pathname: value.link,
                        state: {
                          title: value.title,
                          date: value.date,
                          auteur: value.auteur,
                        },
                      }}
                      tag={Link}
                    >
                      <h5>{value.title}</h5>
                      {value.posterURL === undefined ? (
                        <img
                          src={require(`assets/img/${value.auteurIMG}`).default}
                          alt="img"
                          className="img-Search-pub"
                        />
                      ) : (
                        <img
                          src={require(`assets/img/${value.posterURL}`).default}
                          alt="img"
                          className="img-Search-eve"
                        />
                      )}
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        </Col>
        <Col md="1"></Col>
      </Row>
    </Container>
  );
};

export default SearchField;
